<script setup lang="ts">
// Outline bath. Colour follows CSS `color`.
defineOptions({ inheritAttrs: false })
</script>

<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    v-bind="$attrs"
  >
    <path
      d="M5.83333 2.33333L4.66667 3.5"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke="currentColor"
    />
    <path
      d="M9.91667 11.0833V12.25"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke="currentColor"
    />
    <path
      d="M1.16667 7H12.8333"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke="currentColor"
    />
    <path
      d="M4.08333 11.0833V12.25"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke="currentColor"
    />
    <path
      d="M5.25 2.91667L4.44558 2.11225C4.27689 1.94277 4.0627 1.82581 3.82893 1.77552C3.59516 1.72522 3.35182 1.74374 3.12835 1.82885C2.90489 1.91395 2.71087 2.06199 2.56978 2.25504C2.42868 2.4481 2.34656 2.67791 2.33333 2.91667V9.91667C2.33333 10.2261 2.45625 10.5228 2.67504 10.7416C2.89383 10.9604 3.19058 11.0833 3.5 11.0833H10.5C10.8094 11.0833 11.1062 10.9604 11.325 10.7416C11.5437 10.5228 11.6667 10.2261 11.6667 9.91667V7"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke="currentColor"
    />
  </svg>
</template>
